import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { cleanText } from "../data/site";
import { useEnhanced } from "./Reveal";

export const FaqAccordion = ({ faqs, idPrefix = "faq", defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  const enhance = useEnhanced();
  return (
    <div className="flex flex-col gap-4">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div
            key={f.q}
            data-testid={`${idPrefix}-item-${i}`}
            className={`rounded-2xl border transition-colors duration-500 ${
              isOpen ? "border-accent/30 bg-surface" : "border-white/[0.08] bg-surface/50 hover:border-white/20"
            }`}
          >
            <h3>
              <button
                data-testid={`${idPrefix}-question-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-6 px-6 sm:px-8 py-5 sm:py-6 text-left"
              >
                <span className={`font-display text-base sm:text-lg font-semibold transition-colors ${isOpen ? "text-accent" : "text-slate-100"}`}>
                  {f.q}
                </span>
                <motion.span
                  animate={{ rotate: isOpen ? 45 : 0 }}
                  transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                  className={`shrink-0 rounded-full border p-2 ${isOpen ? "border-accent/50 text-accent" : "border-white/15 text-mute"}`}
                >
                  <Plus size={16} />
                </motion.span>
              </button>
            </h3>
            {isOpen && !enhance && (
              <div className="overflow-hidden">
                <p className="px-6 sm:px-8 pb-6 text-sm sm:text-base text-slate-400 leading-relaxed max-w-3xl">{cleanText(f.a)}</p>
              </div>
            )}
            <AnimatePresence initial={false}>
              {isOpen && enhance && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-6 sm:px-8 pb-6 text-sm sm:text-base text-slate-400 leading-relaxed max-w-3xl">{cleanText(f.a)}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};
